export default __webpack_public_path__ + "static/media/folder.df774aa3.svg";